import React from 'react'
import { BqTabGroup, BqTab } from '@beeq/react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Title, TitleContainer } from './styles'
import { PERMISSION_CODES } from '../../constants/permissions'
import { useSave } from '../../Context/saveContext'
import { Text } from '../../constants/TextConstants'

const RolesPermissionsTabs = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { userPermissions } = useSave()
  const editRolesPermission = userPermissions.includes(PERMISSION_CODES.viewCreateEditRoles.code)

  const routeChange = (path) => {
    navigate(path)
  }

  return (
    <div>
      <TitleContainer>
        <Title>{Text.RolesPermissions}</Title>
      </TitleContainer>
      <BqTabGroup data-testid='tab-group'>
        <BqTab
          active={location.pathname === '/roles'}
          disabled={!editRolesPermission}
          data-testid='tab-roles'
          onBqClick={() => routeChange('/roles')}>
          {Text.RoleManager}
        </BqTab>

        <BqTab
          active={location.pathname === '/roles-assignment'}
          data-testid='tab-users'
          onBqClick={() => routeChange('/roles-assignment')}>
          {Text.Users}
        </BqTab>
      </BqTabGroup>
    </div>
  )
}
export default RolesPermissionsTabs
